module.exports = __webpack_public_path__ + "img/025a8757642d60c5ec3edf790cd7aca2.svg";